import * as React from "react";
import { useCallback } from "react";
import styled from "styled-components";
import trim from "lodash/trim";
import { Formik, Form } from "formik";
import { ModalSubmit, FormikInput } from "components/common";
const FilterInput = styled(FormikInput)`
  margin-bottom: 5px;
`;
const Container = styled.div`
  padding: 3px 10px;
  max-width: 250px;
`;
const validate = ({ value }) => {
  if (!value || trim(value) === "") {
    return { value: "Must not be empty." };
  }
  return {};
};
const GenericFilterInput = ({ filter = void 0, onSubmit }) => {
  const initialValues = { value: filter == null ? void 0 : filter.value };
  const createFilter = useCallback(({ value }) => onSubmit({ title: value, value }, true), [onSubmit]);
  return /* @__PURE__ */ React.createElement(Container, { "data-testid": "generic-filter-form" }, /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: createFilter, validate }, ({ isValid }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(
    FilterInput,
    {
      type: "text",
      id: "generic-filters-input",
      name: "value",
      formGroupClassName: "",
      required: true,
      placeholder: "Enter value to filter for"
    }
  ), /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      submitButtonText: `${filter ? "Update" : "Create"} filter`,
      bsSize: "small",
      disabledSubmit: !isValid,
      displayCancel: false
    }
  ))));
};
export default GenericFilterInput;
